import Repository from '@/libs/axios'

const resource = '/init'

export default {
  createBusinessUser(payload) {
    return Repository.post(`${resource}/register`, payload)
  },
}
